import { $hasClassName, $type } from './constants';
export function makeBatchedStyles(value, hasClassName = true) {
    const styles = value;
    styles[$type] = 'batched';
    styles[$hasClassName] = hasClassName;
    return styles;
}
export function isBatchedStyles(value) {
    return (value === null || value === void 0 ? void 0 : value[$type]) === 'batched';
}
export function isMedia(key) {
    return key.startsWith('@media') || key.startsWith('@supports') || key.startsWith('@container');
}
const selectorPattern = /^[:[.]/;
export function isSelector(key) {
    return selectorPattern.test(key) || key.indexOf('&') !== -1;
}
export function addClassName(props, className) {
    props.className = props.className ? `${props.className} ${className}` : className;
}
export function addStyle(props, style) {
    props.style = Object.assign({}, props.style, style);
}

//# sourceMappingURL=util.js.map